/* eslint-disable no-unused-vars */
import { useState } from 'react';
import Ic from '../Icon';

export default function AddPropertyModal({ onSave, onClose, existing }) {
  const E = existing || {};
  const [saving, setSaving] = useState(false);
  const [error, setError]   = useState('');
  const [form, setForm] = useState({
    name:                E.name || '',
    address:             E.address || E.addr || '',
    type:                E.type || 'Single Family',
    units:               E.units || 1,
    year_built:          E.year_built || E.yr || '',
    purchase_price:      E.purchase_price || E.buy || '',
    purchase_date:       E.purchase_date || E.bd || '',
    current_value:       E.current_value || E.val || '',
    mortgage_balance:    E.mortgage_balance || E.mb || '',
    monthly_payment:     E.monthly_payment || E.mp || '',
    interest_rate:       E.interest_rate || E.mr || '',
    lender:              E.lender || '',
    insurance_carrier:   E.insurance_carrier || E.ins || '',
    insurance_premium:   E.insurance_premium || '',
    insurance_renewal:   E.insurance_renewal || '',
    property_tax_annual: E.property_tax_annual || E.tx || '',
    notes:               E.notes || '',
  });

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const save = async () => {
    if (!form.name || !form.address) { setError('Property name and address are required.'); return; }
    setSaving(true); setError('');
    await onSave({
      name: form.name, address: form.address, type: form.type,
      units:               parseInt(form.units) || 1,
      year_built:          form.year_built ? parseInt(form.year_built) : null,
      purchase_price:      form.purchase_price ? parseFloat(form.purchase_price) : null,
      purchase_date:       form.purchase_date || null,
      current_value:       form.current_value ? parseFloat(form.current_value) : null,
      mortgage_balance:    form.mortgage_balance ? parseFloat(form.mortgage_balance) : null,
      monthly_payment:     form.monthly_payment ? parseFloat(form.monthly_payment) : null,
      interest_rate:       form.interest_rate ? parseFloat(form.interest_rate) : null,
      lender:              form.lender || null,
      insurance_carrier:   form.insurance_carrier || null,
      insurance_premium:   form.insurance_premium ? parseFloat(form.insurance_premium) : null,
      insurance_renewal:   form.insurance_renewal || null,
      property_tax_annual: form.property_tax_annual ? parseFloat(form.property_tax_annual) : null,
      notes:               form.notes || null,
    });
    setSaving(false);
  };

  const FI = ({ label, k, type='text', placeholder='', full=false }) => (
    <div className="fi" style={full?{gridColumn:'1/-1'}:{}}>
      <label>{label}</label>
      <input type={type} value={form[k]} onChange={e=>set(k,e.target.value)} placeholder={placeholder}/>
    </div>
  );

  const SEC = ({ title }) => (
    <div style={{fontSize:11,fontWeight:700,color:'#484f58',letterSpacing:2,textTransform:'uppercase',margin:'20px 0 12px',gridColumn:'1/-1'}}>{title}</div>
  );

  return (
    <div className="mov" onClick={e=>e.target===e.currentTarget&&onClose()}>
      <div className="modal" style={{maxWidth:640,maxHeight:'90vh',overflowY:'auto'}}>
        <div className="mhd">
          <h2>{existing?'Edit Property':'Add Property'}</h2>
          <button className="btn btn-gh" style={{padding:'5px 9px'}} onClick={onClose}><Ic n="x" s={15}/></button>
        </div>
        <div className="mbdy">
          {error && <div style={{background:'rgba(248,81,73,.08)',border:'1px solid rgba(248,81,73,.2)',borderRadius:8,padding:'10px 13px',fontSize:13,color:'#f85149',marginBottom:16}}>{error}</div>}
          <div className="fg">
            <SEC title="Basic Info"/>
            <FI label="Property Name *" k="name" full placeholder="e.g. 123 Main St or Elm Ridge Unit A"/>
            <FI label="Full Address *"  k="address" full placeholder="Street address, City, State ZIP"/>
            <div className="fi"><label>Type</label>
              <select value={form.type} onChange={e=>set('type',e.target.value)}>
                {['Single Family','Multi-Family','Duplex','Triplex','Fourplex','Condo','Townhouse','Commercial'].map(t=><option key={t}>{t}</option>)}
              </select>
            </div>
            <FI label="Number of Units" k="units" type="number" placeholder="1"/>
            <FI label="Year Built"      k="year_built" type="number" placeholder="e.g. 1998"/>

            <SEC title="Value & Purchase"/>
            <FI label="Purchase Price ($)"      k="purchase_price" type="number" placeholder="0.00"/>
            <FI label="Purchase Date"           k="purchase_date" type="date"/>
            <FI label="Current Est. Value ($)"  k="current_value" type="number" placeholder="0.00" full/>

            <SEC title="Mortgage"/>
            <FI label="Mortgage Balance ($)" k="mortgage_balance" type="number" placeholder="0.00"/>
            <FI label="Monthly Payment ($)"  k="monthly_payment" type="number" placeholder="0.00"/>
            <FI label="Interest Rate (%)"    k="interest_rate" type="number" placeholder="6.5"/>
            <FI label="Lender"               k="lender" placeholder="e.g. Wells Fargo"/>

            <SEC title="Insurance & Tax"/>
            <FI label="Insurance Carrier"    k="insurance_carrier" placeholder="e.g. State Farm"/>
            <FI label="Annual Premium ($)"   k="insurance_premium" type="number" placeholder="0.00"/>
            <FI label="Renewal Date"         k="insurance_renewal" type="date"/>
            <FI label="Annual Property Tax ($)" k="property_tax_annual" type="number" placeholder="0.00"/>

            <div className="fi" style={{gridColumn:'1/-1'}}>
              <label>Notes</label>
              <textarea value={form.notes} onChange={e=>set('notes',e.target.value)} placeholder="Additional notes about this property..." style={{minHeight:70}}/>
            </div>
          </div>
          <div style={{display:'flex',gap:10,justifyContent:'flex-end',marginTop:8}}>
            <button className="btn btn-gh" onClick={onClose}>Cancel</button>
            <button className="btn btn-g" onClick={save} disabled={saving}>
              <Ic n="check" s={14}/>{saving?'Saving...':(existing?'Save Changes':'Add Property')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
